export enum EApplicationType {
  Precheckin = 'Precheckin'
}